import dayjs from 'dayjs';

/** Recent chat row: compact relative (39m, 5h, 5d) then calendar (Apr 13). Uses last activity. */
export function formatSessionSidebarTime(iso: string): string {
    const d = dayjs(iso);
    if (!d.isValid()) return '';
    const now = dayjs();
    const diffMs = now.valueOf() - d.valueOf();
    if (diffMs < 0) {
        return d.year() === now.year() ? d.format('MMM D') : d.format('MMM D, YYYY');
    }
    if (diffMs < 60_000) return 'just now';
    const diffM = Math.floor(diffMs / 60_000);
    if (diffM < 60) return `${diffM}m ago`;
    const diffH = Math.floor(diffMs / 3_600_000);
    if (diffH < 24) return `${diffH}h ago`;
    const diffD = Math.floor(diffMs / 86_400_000);
    if (diffD < 7) return `${diffD}d ago`;
    if (d.year() === now.year()) return d.format('MMM D');
    return d.format('MMM D, YYYY');
}
